<template>
  <div class="progress">
    <div class="bar-wrap">
      <div class="bar" :style="{width:modelValue+'%'}"></div>
    </div>
    <div class="progress-value" v-if="showProgress">{{modelValue}}%</div>
  </div>
</template>

<script>
export default {
  props: {
    //进度值
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    // 是否显示进度数值
    showProgress: {
      type: Boolean,
      default: false,
    },
    //进度条宽度
    size: {
      type: Number,
      default: 240,
    },
    // 进度条颜色
    color: {
      type: String,
      default: '#FE7700',
    },
    // 进度值颜色
    textColor: {
      type: String,
      default: '#FE7700',
    },
    // 进度条背景颜色
    bgColor: {
      type: String,
      default: '#dbdbdb',
    },
  },
  data() {
    return {
      wrapWidth: 0,
    }
  },
  mounted() {
    this.wrapWidth = this.ratio * this.size + 'px'
  },
}
</script>

<style scoped>
.progress {
  display: flex;
  align-items: center;
  width: v-bind(wrapWidth);
}
.bar-wrap {
  position: relative;
  flex: 1 0 0;
  border-radius: 4px;
  height: 8px;
  background-color: v-bind(bgColor);
}
.bar {
  border-radius: 4px;
  height: 100%;
  background-color: v-bind(color);
  position: absolute;
  top: 0;
  left: 0;
}
.progress-value {
  padding-left: 12px;
  color: v-bind(textColor);
  font-weight: bold;
}
</style>